import { handleAdminQuantityDefinitionCreated } from "./admin";
import { handleUserQuantityDefinitionCreated } from "./user";

export function handleQuantityDefintionCreated(state, patch) {
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionCreated(state, payload);
    }

    return handleUserQuantityDefinitionCreated(state, payload);
}